import { getUniversityNavLinks } from "@/pages/education/universities/[universityId]/_universityNav";
import { useFlags } from "@/hooks/useFeatureFlags";
import MobileNavigation from "./MobileNavigation";

export interface MobileUniversityNavigationProps {
  universityId: string;
}

export default function MobileUniversityNavigation({ universityId }: MobileUniversityNavigationProps) {
  const flags = useFlags();
  const navLinks = getUniversityNavLinks(universityId, {
    includeReports: !!flags["backoffice-university-reports"]
  });

  return <MobileNavigation links={navLinks} testId="mobile-university-navigation" />;
}
